import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled('div')(() => ({
	flex: '1 1 auto',
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
}));

export const Title = styled(Typography, {
	shouldForwardProp: (prop) => prop !== 'marginBottom',
})<{ marginBottom?: string }>(({ theme, marginBottom }) => ({
	...theme.typography.body1,
	marginBottom: marginBottom || 0,
}));
